let apiBase = {
  queryMemberContactList: '/api/show/queryMemberContactList',
  queryFlowSupportList: '/api/p/H5Config/queryList',
  queryFlowSupportInfo: '/api/p/H5Config/detail',

}
let singleHomeServerObject = null

class HomeServer {
    constructor() {}
    //获取厂商联系list
    queryMemberContactList(params = {}) {
        return $http({
            method: 'get',
            url: apiBase.queryMemberContactList,
            params: params,
        })
    }
    //获取风运营支持计划活动List
    queryFlowSupportList(params = {}) {
        return $http({
            method: 'get',
            url: apiBase.queryFlowSupportList,
            params: params,
        })
    }
}

function singleHomeServer() {
    if (singleHomeServerObject === null) {
        singleHomeServerObject = new HomeServer()
    }
    return singleHomeServerObject
}

export default singleHomeServer()